import { HomeIcon, MainMenu } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { getDashboardPath } from '../routes';
import { dashboardTranslationKeys } from '../translations';

export const DashboardNavigationItem = (): JSX.Element | null => {
   return protectFeature(
      'medicalDashboard',
      <MainMenu.NavigationItem
         testId={'dashboard'}
         path={getDashboardPath()}
         icon={<HomeIcon />}
         label={dashboardTranslationKeys.navigationItem}
      />,
      null
   );
};
